import { compose } from 'recompose'
import { connect } from 'react-redux'
import { selectClientHomes } from 'src/store/selectors/client'

const withLoadedFromHomesAndClients = compose(
  connect(state => {
    const homes = selectClientHomes(state)
    const loadingClient = state.client.loadingData
    const loadingHomes = state.client.loadingHomes

    return {
      // Don't show when loading.
      // Homes are needed to show, at the moment. If they are a homeowner on HO
      // route, this will return successully and delegate to the component. If
      // they are a buyer without homes, there is no need to show the nav
      loaded: homes && !loadingHomes && !loadingClient
    }
  })
)

export default withLoadedFromHomesAndClients
